import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "max-w-[144px]" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 0,
  class: "absolute left-2 bottom-2 right-2"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "price" }
const _hoisted_11 = { class: "woocommerce-Price-amount amount" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "woocommerce-Price-amount amount" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_17 = { key: 1 }

import { computed, ref } from 'vue';
import Bag from '../icons/Bag.vue';


export default {
  __name: 'SingleProductCrossSell',
  props: {
    item: Object,
    toggleSelected: Function,
    isSelected: Function,
},
  setup(__props) {

const props = __props;



const variations = props.item.variations.filter((variation) => variation.in_stock);
const selectedVariation = ref(variations[0] || null);

const isSelected = computed(() => {
    return props.isSelected({ id: props.item.id });
});

const onOpen = (e, url) => {
    if (typeof window !== 'undefined') {
        e.preventDefault();
        e.stopPropagation();
        const w = window.open(url, '_blank', 'noopener,noreferrer');
        if (w) w.opener = null;
        return;
    }
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: props.item.link,
        target: "_blank",
        rel: "noopener",
        onClick: _cache[0] || (_cache[0] = $event => (onOpen($event, props.item.link)))
      }, [
        _createElementVNode("img", {
          class: "w-full h-full object-cover object-center aspect-[14/20]",
          src: selectedVariation.value?.id ? selectedVariation.value.thumb : props.item.thumb,
          alt: props.item.name
        }, null, 8, _hoisted_4)
      ], 8, _hoisted_3),
      (_unref(variations) && _unref(variations).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _withDirectives(_createElementVNode("select", {
              class: "w-full text-[14px] rounded-[16px] px-[6px] py-[5px]",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((selectedVariation).value = $event)),
              disabled: _unref(isSelected)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(variations), (variation) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: variation.id,
                  value: variation
                }, _toDisplayString(Object.values(variation.attrs)
                                .map((v) => v.toUpperCase())
                                .join(' / ')), 9, _hoisted_7))
              }), 128))
            ], 8, _hoisted_6), [
              [_vModelSelect, selectedVariation.value]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("a", {
      href: props.item.link,
      target: "_blank",
      rel: "noopener",
      onClick: _cache[2] || (_cache[2] = $event => (onOpen($event, props.item.link))),
      class: "block text-[14px] text-greyScale900 mt-2 text-overwrap"
    }, _toDisplayString(props.item.name), 9, _hoisted_8),
    (props.item.has_discount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, [
            _createElementVNode("del", null, [
              _createElementVNode("span", _hoisted_11, [
                _createElementVNode("bdi", {
                  innerHTML: props.item.regular_price
                }, null, 8, _hoisted_12)
              ])
            ]),
            _createElementVNode("ins", null, [
              _createElementVNode("span", _hoisted_13, [
                _createElementVNode("bdi", {
                  innerHTML: props.item.price
                }, null, 8, _hoisted_14)
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          innerHTML: props.item.price
        }, null, 8, _hoisted_15)),
    _createElementVNode("button", {
      class: _normalizeClass({
                'Button !py-[6px] !min-h-min !mt-2 !rounded-[4px] !min-w-min !w-full': true,
                '!bg-greyScale200 !text-greyScale900 hover:!bg-greyScale300': _unref(isSelected),
            }),
      onClick: _cache[3] || (_cache[3] = $event => (
                props.toggleSelected({
                    id: props.item.id,
                    variation_id: selectedVariation.value?.id || null,
                })
            ))
    }, [
      (!_unref(isSelected))
        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
            _createTextVNode(" Dodaj "),
            _createVNode(Bag)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_17, " Usuń "))
    ], 2)
  ]))
}
}

}